export default __webpack_public_path__ + "static/media/heart-monitor.dba545b3.svg";